/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AccountEnabledPatchForm } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { InfoPersonaliPatchForm } from '../model/models';
import { OperatorePraticaCreationForm } from '../model/models';
import { OperatorePraticaDTO } from '../model/models';
import { OperatorePraticaListFilter } from '../model/models';
import { OperatorePraticaPatchForm } from '../model/models';
import { OperatoreStatoAccessoDTO } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelOperatorePraticaDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface AvviaResetPasswordOperatorePraticaRequestParams {
    userId: string;
}

export interface ClearBruteForceLockoutOperatorePraticaRequestParams {
    userId: string;
}

export interface CreateOperatorePraticaRequestParams {
    operatorePraticaCreationForm: OperatorePraticaCreationForm;
}

export interface DeleteOperatorePraticaRequestParams {
    userId: string;
}

export interface EditInfoPersonaliOperatorePraticaRequestParams {
    userId: string;
    infoPersonaliPatchForm: InfoPersonaliPatchForm;
}

export interface GetOperatorePraticaDetailRequestParams {
    userId: string;
}

export interface GetResetPasswordLinkOperatorePraticaRequestParams {
    userId: string;
}

export interface GetStatoAccessoOperatorePraticaRequestParams {
    userId: string;
}

export interface GetVerificationLinkOperatorePraticaRequestParams {
    userId: string;
}

export interface ListOperatoriPraticaRequestParams {
    filter: OperatorePraticaListFilter;
    pageable: Pageable;
}

export interface ReinviaVerificaOperatorePraticaRequestParams {
    userId: string;
}

export interface SetAccountEnabledOperatorePraticaRequestParams {
    userId: string;
    accountEnabledPatchForm: AccountEnabledPatchForm;
}

export interface UpdateOperatorePraticaRequestParams {
    userId: string;
    operatorePraticaPatchForm: OperatorePraticaPatchForm;
}


export interface OperatoriPraticaServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Invia l\&#39;email di reset password a un operatore-pratica.
     * Audience: SUPERADMIN, ADMIN, OP_COMUNE (solo nei propri comuni). Solo su un account attivo; emette un token nuovo, quindi un link di reset copiato in precedenza smette di funzionare.
     * @endpoint post /api/v1/gestione/operatori-pratica/{user_id}/reset-password
* @param requestParameters
     */
    avviaResetPasswordOperatorePratica(requestParameters: AvviaResetPasswordOperatorePraticaRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Cancella il brute-force lockout Keycloak di un operatore-pratica.
     * Sblocca un OP_PRATICA bloccato da Keycloak per troppi tentativi di login falliti. Il blocco vive solo in Keycloak (nessuna colonna locale) e non è impostabile dal backoffice: qui si può solo rimuoverlo. Gemello degli omologhi operatori-comune e operatori-servizio-mensa. 400 se l\&#39;utente non ha keycloakSubjectId.
     * @endpoint delete /api/v1/gestione/operatori-pratica/{user_id}/brute-force-lockout
* @param requestParameters
     */
    clearBruteForceLockoutOperatorePratica(requestParameters: ClearBruteForceLockoutOperatorePraticaRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Crea un nuovo operatore-pratica.
     * Audience: SUPERADMIN, ADMIN, OP_COMUNE. OP_COMUNE puo\&#39; creare solo nei propri comuni gestiti. Authority ammesse nel form: OP_PRATICA, OP_PRATICA_ESERCENTE.
     * @endpoint post /api/v1/gestione/operatori-pratica
* @param requestParameters
     */
    createOperatorePratica(requestParameters: CreateOperatorePraticaRequestParams, extraHttpRequestParams?: any): Observable<OperatorePraticaDTO>;

    /**
     * Cancella un operatore-pratica (SUPERADMIN).
     * Rimozione utente KC + assegnazioni per-bando + push token + delete locale. Audience ristretta al SUPERADMIN, piu\&#39; stretta delle altre azioni di questa risorsa (ADMIN/OP_COMUNE): la cancellazione di un account e\&#39; irreversibile. 404 privacy-preserving se il target non esiste o non e\&#39; un operatore-pratica; 409 se ha dati storici referenziati (usare la disabilitazione come alternativa).
     * @endpoint delete /api/v1/gestione/operatori-pratica/{user_id}
* @param requestParameters
     */
    deleteOperatorePratica(requestParameters: DeleteOperatorePraticaRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Modifica nome/cognome di un operatore-pratica.
     * Audience: SUPERADMIN, ADMIN, OP_COMUNE (solo nei propri comuni). Campi null &#x3D; no-op per quel campo. Almeno uno tra nome/cognome richiesto (400 info_personali_almeno_un_campo). Sync KC firstName/lastName best-effort.
     * @endpoint patch /api/v1/gestione/operatori-pratica/{user_id}/info
* @param requestParameters
     */
    editInfoPersonaliOperatorePratica(requestParameters: EditInfoPersonaliOperatorePraticaRequestParams, extraHttpRequestParams?: any): Observable<OperatorePraticaDTO>;

    /**
     * Detail di un operatore-pratica per id.
     * Audience: SUPERADMIN, ADMIN, OP_COMUNE (solo nei propri comuni). Parity coi sibling operatori-comune / operatori-servizio-mensa: evita al FE di paginare l\&#39;intera lista per trovare una riga. 404 privacy-preserving se l\&#39;utente non esiste, non e\&#39; un operatore-pratica, o e\&#39; fuori scope del caller.
     * @endpoint get /api/v1/gestione/operatori-pratica/{user_id}
* @param requestParameters
     */
    getOperatorePraticaDetail(requestParameters: GetOperatorePraticaDetailRequestParams, extraHttpRequestParams?: any): Observable<OperatorePraticaDTO>;

    /**
     * Genera il link di reset password per un operatore-pratica.
     * Audience: SUPERADMIN, ADMIN, OP_COMUNE (solo nei propri comuni). Verbo POST per side-effect server-side (genera/persiste un JTI).
     * @endpoint post /api/v1/gestione/operatori-pratica/{user_id}/get-reset-password-link
* @param requestParameters
     */
    getResetPasswordLinkOperatorePratica(requestParameters: GetResetPasswordLinkOperatorePraticaRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Stato di accesso di un operatore-pratica letto da Keycloak.
     * Espone il blocco per tentativi di accesso falliti, che vive solo in Keycloak e non è rispecchiato da alcuna colonna locale: serve al backoffice per offrire lo sblocco solo a chi è davvero bloccato. Lettura separata dal dettaglio perché interroga Keycloak: un fermo di Keycloak dà 400 qui senza impedire il caricamento della scheda operatore. Operatore senza identità Keycloak → stato vuoto (niente da bloccare), non un errore.
     * @endpoint get /api/v1/gestione/operatori-pratica/{user_id}/stato-accesso
* @param requestParameters
     */
    getStatoAccessoOperatorePratica(requestParameters: GetStatoAccessoOperatorePraticaRequestParams, extraHttpRequestParams?: any): Observable<OperatoreStatoAccessoDTO>;

    /**
     * Genera il link di verifica email per un operatore-pratica.
     * Audience: SUPERADMIN, ADMIN, OP_COMUNE (solo nei propri comuni). Verbo POST per side-effect server-side (genera/persiste un JTI).
     * @endpoint post /api/v1/gestione/operatori-pratica/{user_id}/get-verification-link
* @param requestParameters
     */
    getVerificationLinkOperatorePratica(requestParameters: GetVerificationLinkOperatorePraticaRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Lista paginata degli operatori-pratica.
     * Filtri opzionali: comune_id, q (email/nome/cognome), enabled. OP_COMUNE caller vede automaticamente solo i propri (scope su comuniGestiti). Default sort: email ASC.
     * @endpoint get /api/v1/gestione/operatori-pratica
* @param requestParameters
     */
    listOperatoriPratica(requestParameters: ListOperatoriPraticaRequestParams, extraHttpRequestParams?: any): Observable<PagedModelOperatorePraticaDTO>;

    /**
     * Reinvia l\&#39;email di attivazione a un operatore-pratica.
     * Audience: SUPERADMIN, ADMIN, OP_COMUNE (solo nei propri comuni). Solo con un invito in attesa; riusa il token dell\&#39;invito, quindi un link di attivazione copiato in precedenza resta valido.
     * @endpoint post /api/v1/gestione/operatori-pratica/{user_id}/reinvia-verifica
* @param requestParameters
     */
    reinviaVerificaOperatorePratica(requestParameters: ReinviaVerificaOperatorePraticaRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Soft-delete o riattivazione di un operatore-pratica.
     * Idempotente: PATCH con stesso valore di enabled non chiama KC. Su disable revoca anche le sessioni KC. NON cancella righe user_tipo_pratica.
     * @endpoint patch /api/v1/gestione/operatori-pratica/{user_id}/account-enabled
* @param requestParameters
     */
    setAccountEnabledOperatorePratica(requestParameters: SetAccountEnabledOperatorePraticaRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Modifica authorities e/o comuni gestiti di un operatore-pratica.
     * Campi assenti &#x3D; no-op. Set vuoti rifiutati. Lo scope di comune e\&#39; verificato PRIMA e DOPO l\&#39;update per OP_COMUNE caller.
     * @endpoint put /api/v1/gestione/operatori-pratica/{user_id}
* @param requestParameters
     */
    updateOperatorePratica(requestParameters: UpdateOperatorePraticaRequestParams, extraHttpRequestParams?: any): Observable<OperatorePraticaDTO>;

}
